import { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../../redux/store";

import {
  // Avatar,
  Box,
  Button,
  Drawer,
  Tabs,
  Tab,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { closeDrawer, fetchUserById } from "../usersSlice";
import { fetchCustomers } from "../../../../redux/slices/customersSlice";
import Info from "./Tabs/Info";
import HistoryTab from "./Tabs/ChangeLog";
import SetTemporaryPasswordDialog from "./SetTemporaryPasswordDialog";
// import ProfilePicture from "../../../dashboard/account-settings/components/profilePicture";

const TabPanel = ({ children, value, index }: any) => (
  <div hidden={value !== index}>
    {value === index && <Box>{children}</Box>}
  </div>
);

export default function UserDrawer() {
  const { drawerOpen, userId, status, selectedUser } = useAppSelector(
    (state) => state.users
  ) as any;

  const customersStatus = useAppSelector((state) => state.customers?.status);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (customersStatus === "idle") {
      dispatch(fetchCustomers());
    }
  }, [dispatch, customersStatus]);

  useEffect(() => {
    if (drawerOpen && (userId !== "" || (userId !== "" && status === "idle"))) {
      dispatch(fetchUserById(userId));
    }
  }, [dispatch, drawerOpen, userId, status]);

  const onClose = () => {
    dispatch(closeDrawer());
  };

  const [value, setValue] = useState(0);
  const [temporaryPasswordOpen, setTemporaryPasswordOpen] = useState(false);

  const handleChange = (_event: any, newValue: any) => setValue(newValue);

  return (
    <Drawer
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(19, 21, 23, 0.45)",
        },
        "& .MuiDrawer-paper": {
          mt: 7,
          backgroundColor: "var(--surface-container-lowest, #ffffff)",
          height: "calc(100% - 56px)",
          borderRadius: 0,
          border: "1px solid var(--outline-variant, #dcdcdc)",
          width: "100%",
          maxWidth: "900px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1)",
        },
      }}
      anchor="right"
      open={drawerOpen}
      onClose={onClose}
    >
      <Box
        sx={{
          px: { xs: 2.5, sm: 3 },
          py: { xs: 2, sm: 2.5 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid var(--outline-variant, #dcdcdc)",
        }}
      >
        <Box
          sx={{
            minWidth: 0,
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            {selectedUser ? "Edit User" : "Add User"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {/* An existing user can be handed a way in when mail cannot reach
              them; there is nothing to set for a user being created. */}
          {selectedUser && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => setTemporaryPasswordOpen(true)}
            >
              Set temporary password
            </Button>
          )}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          flex: 1,
          overflowY: "auto",
          px: { xs: 2.5, sm: 3 },
          py: { xs: 2.5, sm: 3 },
        }}
      >
          <Tabs value={value} onChange={handleChange} aria-label="info tabs" sx={{ mb: 2.5 }}>
            <Tab label="General Info" />
            <Tab label="Transactions" />
            <Tab label="History" />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Info />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Typography>Transactions Content</Typography>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <HistoryTab />
          </TabPanel>
      </Box>

      <SetTemporaryPasswordDialog
        open={temporaryPasswordOpen}
        onClose={() => setTemporaryPasswordOpen(false)}
        user={selectedUser}
      />
    </Drawer>
  );
}
